// src/index.ts
import { HoneycombWebSDK } from "@honeycombio/opentelemetry-web";
import { getWebAutoInstrumentations } from "@opentelemetry/auto-instrumentations-web";
var buildCollectorEndpoint = (env) => {
  if (env === "development") {
    return "/v1/traces";
  } else if (env === "staging") {
    return "https://otel-collector-browser.flywire.lol";
  } else if (env === "demo-production" || env === "production") {
    return "https://otel-collector-browser.flywire.com";
  } else {
    return "https://otel-collector-browser.flywire.cc";
  }
};
var bearerToken = (env) => {
  if (env === "demo-production" || env === "production") {
    return "LagartusEdus021";
  } else if (env === "staging") {
    return "Lagart021";
  } else {
    return "hola";
  }
};
var initializeTracing = ({
  serviceName,
  env,
  allowedTracingDomains,
  attributes = {}
}) => {
  if (globalThis.FLYWIRE_FLOTEL_JS_INSTANCE) {
    console.log("Flotel-js has already been initialized. Returning the existing instance.");
    return globalThis.FLYWIRE_FLOTEL_JS_INSTANCE;
  }
  const configDefaults = {
    ignoreNetworkEvents: true,
    allowedTracingDomains
  };
  const inTestMode = env === "test";
  if (inTestMode && !globalThis.OTEL_IN_MEMORY_EXPORTER_INSTANCE) {
    throw new Error(
      `The global variable \`OTEL_IN_MEMORY_EXPORTER_INSTANCE\` and \`OTEL_IN_MEMORY_PROCESSOR_INSTANCE\` must be exported with a new InMemorySpanExporter instance from the @opentelemetry/api package.
      Example:

      globalThis.OTEL_IN_MEMORY_EXPORTER_INSTANCE = new InMemorySpanExporter();
      globalThis.OTEL_IN_MEMORY_PROCESSOR_INSTANCE = new SimpleSpanProcessor(
        globalThis.OTEL_IN_MEMORY_EXPORTER_INSTANCE
      );

      If the test framework in question is jest, please refer to their document page: https://jestjs.io/docs/configuration#globalsetup-string on how to set up a global variable
      `
    );
  }
  const sdk = new HoneycombWebSDK({
    debug: env === "development",
    endpoint: buildCollectorEndpoint(env),
    headers: {
      Authorization: `Bearer ${bearerToken(env)}`
    },
    serviceName,
    resourceAttributes: { ...buildAttributes(attributes), "deployment.environment": env },
    skipOptionsValidation: true,
    // because we are not including apiKey we need to skip it
    instrumentations: !inTestMode ? [
      getWebAutoInstrumentations({
        "@opentelemetry/instrumentation-xml-http-request": configDefaults,
        "@opentelemetry/instrumentation-fetch": configDefaults,
        "@opentelemetry/instrumentation-document-load": configDefaults,
        "@opentelemetry/instrumentation-user-interaction": {
          enabled: false
        }
      })
    ] : [],
    localVisualizations: env === "development",
    spanProcessors: inTestMode ? (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      [globalThis.OTEL_IN_MEMORY_PROCESSOR_INSTANCE]
    ) : void 0
  });
  if (inTestMode && sdk._tracerProviderConfig?.spanProcessor?.spanProcessors) {
    sdk["_tracerProviderConfig"]["spanProcessor"]["spanProcessors"] = sdk["_tracerProviderConfig"]["spanProcessor"]["spanProcessors"].slice(-1);
  }
  sdk.start();
  globalThis.FLYWIRE_FLOTEL_JS_INSTANCE = sdk;
  return sdk;
};
var buildAttributes = (attributes, prefix = "app") => {
  const flatten = (item, path) => {
    if (typeof item !== "object" || item === null) {
      return [[path, item]];
    }
    return Object.entries(item).flatMap(([key, value]) => {
      const newPath = path === prefix && key.startsWith(`${prefix}.`) ? key : `${path}.${key}`;
      return flatten(value, newPath);
    });
  };
  return Object.fromEntries(
    flatten(attributes, prefix).reduce((acc, [key, value]) => {
      acc.set(key, value);
      return acc;
    }, /* @__PURE__ */ new Map())
  );
};
export {
  buildAttributes,
  initializeTracing
};
//# sourceMappingURL=index.js.map
